export const getFormattedPrice = price => {
  if (!price) return

  return Math.abs(price).toFixed(2)
}
